import type { Ref } from 'vue'

interface UseLockedBoolean {
  locked: Ref<boolean>
  lock(): void
  unlock(opts?: { confirm?: string }): boolean
  tryLock(opts?: { confirm?: string }): boolean
}

export function useLockedBoolean(): UseLockedBoolean {
  const locked = ref(false)

  function lock() {
    locked.value = true
  }

  function unlock(opts: { confirm?: string } = {}): boolean {
    if (opts.confirm && !confirm(opts.confirm)) {
      return false
    }

    locked.value = false
    return true
  }

  function tryLock(opts: { confirm?: string } = {}): boolean {
    return !locked.value || unlock(opts)
  }

  return { locked, lock, unlock, tryLock }
}
